// Breach Step 4: Data Affected
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../../../components/ui/card';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';
import { Checkbox } from '../../../../components/ui/checkbox';
import { SCORED_DATA_CATEGORIES, WHO_AFFECTED_OPTIONS, MAX_POINTS } from '../constants';
import { PointsBar, ScoredAccordionGroup, ChipGrid } from '../../../../components/workflow';

export default function Step4DataAffected({ formData, updateField, pointsBreakdown, volScore }) {
  return (
    <div className="space-y-6">
      <div><h2 className="text-2xl font-bold">Data Affected</h2>
        <p className="text-muted-foreground mt-1">Each data category carries a point value reflecting its sensitivity weight under GDPR Art. 9 and ENISA methodology.</p></div>

      <Card>
        <CardContent className="pt-6 space-y-3">
          <h3 className="text-sm font-medium text-muted-foreground">Scoring Summary</h3>
          <PointsBar label="Data Sensitivity" current={pointsBreakdown.data_sensitivity} max={MAX_POINTS.data_sensitivity} />
          <PointsBar label="Ease of Identification" current={pointsBreakdown.identification} max={MAX_POINTS.identification} />
          <PointsBar label="Vulnerability" current={pointsBreakdown.vulnerability} max={MAX_POINTS.vulnerability} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-3"><CardTitle className="text-base">Data Categories</CardTitle><CardDescription>Points are accumulated per ENISA DPC methodology</CardDescription></CardHeader>
        <CardContent>
          <ScoredAccordionGroup categories={SCORED_DATA_CATEGORIES} selected={formData.data_categories} onChange={v => updateField('data_categories', v)} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-3"><CardTitle className="text-base">Who Was Affected</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <ChipGrid options={WHO_AFFECTED_OPTIONS} selected={formData.who_affected} onChange={v => updateField('who_affected', v)} />
          <div className="flex items-center gap-4 pt-2 border-t">
            <Label className="whitespace-nowrap">Number affected</Label>
            <Input data-testid="number-affected" type="number" value={formData.number_affected || ''}
              onChange={e => updateField('number_affected', parseInt(e.target.value) || 0)} className="w-32" min={0} />
            <label className="flex items-center gap-2 cursor-pointer">
              <Checkbox checked={formData.number_affected_estimate} onCheckedChange={v => updateField('number_affected_estimate', v)} />
              <span className="text-sm text-muted-foreground">Estimate</span>
            </label>
          </div>
          {formData.number_affected > 0 && (
            <div className="text-xs text-muted-foreground">
              Volume score: <span className="font-mono font-medium">{volScore}/100</span> (logarithmic scale)
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
